<script>
import BackgroundVideo from '@phoenix/mixins/components/molecules/BackgroundVideo';
import { PhxIcon } from '@phx-styleguides/jlc';

export default {
  components: {
    PhxIcon,
  },

  mixins: [BackgroundVideo],

  props: {
    hasControls: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<template>
  <div :id="videoId" class="video-player background-video">
    <video class="background-video__video" :poster="posterSrc" autoplay muted playsinline loop>
      <source :data-src="videoSrc" :type="sourceType" />
    </video>

    <button
      v-if="hasControls"
      class="background-video__controls"
      type="button"
      :aria-label="$t('Accessibility.videoPlay')"
    >
      <phx-icon icon="play-16" class="background-video__icon background-video__icon--play" />
      <phx-icon icon="pause-16" class="background-video__icon background-video__icon--pause" />
    </button>

    <div class="loader loader--light loader--sm background-video__loader">
      <div class="loader__inner"></div>
    </div>
  </div>
</template>
